import React from 'react';

import {
    PASSWORD_MIN_LENGTH,
} from './validators-consts';

export const REQUIRED_ERROR = 'Wymagane';

export const PASSWORD_MIN_LENGTH_ERROR = `Co najmniej ${PASSWORD_MIN_LENGTH} znaków`;

export const PASSWORD_CONFIRM_ERROR = 'Hasła nie pasują';

export const EMAIL_ERROR = 'Nieprawidłowy adres e-mail';

export const EMAIL_TAKEN_ERROR = 'Adres e-mail już istnieje';

